import React from 'react';

const NfIcon = ({ size, x = '-3', y = '22', className }) => (
  <svg width={size} height={size} viewBox="0 0 25.414 30.414" xmlns="http://www.w3.org/2000/svg" className={className}>
    <text x={x} y={y} fill="#FFF" fontWeight="bold">
      NF
    </text>
  </svg>
);

export default NfIcon;
